<div class="container">
    <div class="image_login">
    </div>
    <div class="form_container" *ngIf="!newPassword">
        <div class="image_login_logo">
        </div>
        <div class="login_form" *ngIf="!resetPassword">
            <form [formGroup]="loginForm">
                <div class="formGroup">
                    <div class="container__input--stacked margin__bottom--100">
                        <label for="username" class="formGroup__title"><span class="red_span">*</span> User
                            Name</label>
                        <input class="input_field_login" type="text" placeholder="Enter your user name"
                            formControlName="username" id="username" />
                        <app-form-inline-error
                            [errorControlName]="convertToFormControl(loginForm!.controls['username'])"
                            [messageConfig]="loginFormErrors!.username"
                            [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                    </div>
                </div>

                <div class="formGroup">
                    <i (click)="togglePasswordFieldType()">
                        <div *ngIf="isTextFieldType; else passwordVisible">
                            <collab-comp-img-generator imageType="icon" fontClassName="icon-View_Off"
                                imageAltText="hide password"></collab-comp-img-generator>
                        </div>
                        <ng-template #passwordVisible><collab-comp-img-generator imageType="icon"
                                fontClassName="icon-View_On"
                                imageAltText="show password"></collab-comp-img-generator></ng-template>
                    </i>
                    <div class="container__input--stacked margin__bottom--100">
                        <label for="password" class="formGroup__title"><span class="red_span">*</span>
                            Password</label>
                        <input type="password" class="input_field_login" [type]="isTextFieldType? 'password': 'text'"
                            placeholder="Enter password" formControlName="password" id="password" />
                        <app-form-inline-error
                            [errorControlName]="convertToFormControl(loginForm!.controls['password'])"
                            [messageConfig]="loginFormErrors!.password"
                            [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                    </div>
                    <div *ngIf="errors.length > 0" class="text_error">
                        <app-form-inline-error [errors]="errors" [isEmpty]="!isEmpty"
                            [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                    </div>
                    <div class="forget-password"><a target="_blank" rel="noopener" (click)="forgetForm()">Forgot
                            Password ?</a></div>
                    <div *ngIf="isSuccess" class="text_success">
                        {{sucessMessage}}
                    </div>


                    <collab-comp-button type="button" class="login-button " [buttonConfig]="loginButtonConfig"
                        (click)="login()"></collab-comp-button>
                </div>

            </form>

            <div class="terms-container">
                <p class="terms_conditions">By logging in I agree with the <button (click)="openModal()">Terms &
                        Conditions</button></p>
            </div>
            <!-- <hr>
            <div>
                <p class="contact_info">Please reach out to us if you have any 
                    questions related to Ascendion AVA </p>
            </div>
            <div class="contact_button">
                <collab-comp-button type="button" [buttonConfig]="contactUsButtonConfig"
                        (onBtnClick)="contactUs()"></collab-comp-button>
            </div> -->
        </div>
        <div class="login_form" *ngIf="resetPassword">
            <div class="forget-container">
                <h6>Forgot Password ?</h6>
                <p>Please enter your email and we will send you the instructions on how to
                    reset your password</p>
            </div>
            <div *ngIf="!confirmEmail">
                <form [formGroup]="resetEmail">
                    <div class="formGroup">
                        <div class="container__input--stacked margin__bottom--100">
                            <label for="email" class="formGroup__title"><span class="red_span">*</span> User
                                Email</label>
                            <input class="input_field_login" type="text" placeholder="Enter your Email"
                                formControlName="email" id="email" 
                                [ngClass]="{input__error: (resetEmail.controls['email'].touched || isEmailFormSubmitted) && !resetEmail.controls['email'].valid}" />
                            <app-form-inline-error
                                [errorControlName]="convertToFormControl(resetEmail!.controls['email'])"
                                [messageConfig]="resetFormErrors!.email"
                                [isSubmitted]="isEmailFormSubmitted"></app-form-inline-error>
                        </div>
                        <div *ngIf="emailerrors.length > 0" class="text_error">
                            <app-form-inline-error [errors]="emailerrors" [isEmpty]="!isEmpty"
                                [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                        </div>
                    </div>
                    <collab-comp-button type="button" class="login-button " [buttonConfig]="ResetPasswordButtonConfig"
                        (click)="onResetPassword()"></collab-comp-button>
                </form>
            </div>
            <div *ngIf="confirmEmail">
                <div class="form-confirmation">
                    <div #success><collab-comp-img-generator imageType="icon"
                            fontClassName="icon-Success"></collab-comp-img-generator></div>
                    <div>
                        <div class="text-bold">Instructions Sent</div>
                        <div>We have sent you the instructions on how to reset your password</div>
                    </div>

                </div>
                <collab-comp-button type="button" class="login-button " [buttonConfig]="BackToLoginButtonConfig"
                    (click)="backToLogin()"></collab-comp-button>
            </div>
        </div>

        <div class="footer">
            <p>&copy; 2023 Ascendion AVA.</p>
        </div>
    </div>

    <div class="form_container" *ngIf="newPassword">
        <div class="image_login_logo">
        </div>
        <div class="login_form">
            <app-password-reset-page></app-password-reset-page>
        </div>
        <div class="footer">
            <p>&copy; 2023 Ascendion AVA.</p>
        </div>

    </div>
    <collab-comp-modal *ngIf="modalConfig" [modalConfig]="modalConfig" (modalClosed)="closeModal()"
    (primaryButtonSelected)="closeModal()">
    <app-terms-policy></app-terms-policy>
</collab-comp-modal>

    <!-- <div class="container__login container__mainContent">
    <h1>USER LOGIN</h1>

    <div class="container__login--body">
        <form [formGroup]="loginForm">
            <div class="formGroup">
                <span class="material-icons">person</span>
                <div class="container__input--stacked margin__bottom--100">
                    <label for="username" class="formGroup__title">User Name</label>
                    <input type="text" placeholder="Enter your user name" formControlName="username" id="username"/>
                    <app-form-inline-error [errorControlName]="convertToFormControl(loginForm!.controls['username'])" [messageConfig]="loginFormErrors!.username"
                        [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                </div>
            </div>
        
            <div class="formGroup">
                <i (click)="togglePasswordFieldType()">
                    <div *ngIf="isTextFieldType; else passwordVisible">
                        <img src={{invisible}} alt="hide password">
                    </div>
                    <ng-template #passwordVisible><img src={{visible}} alt="show password"></ng-template>               
                </i>
                <span class="material-icons">lock</span>
                <div class="container__input--stacked margin__bottom--100">
                    <label for="password" class="formGroup__title">Password</label>
                    <input type="password" [type]="isTextFieldType? 'password': 'text'" placeholder="Enter password" formControlName="password" id="password"/>
                    <app-form-inline-error [errorControlName]="convertToFormControl(loginForm!.controls['password'])" [messageConfig]="loginFormErrors!.password"
                        [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                </div>
                <div *ngIf="errors.length > 0" class="text_error">
                    <app-form-inline-error [errors]="errors" [isEmpty]="!isEmpty" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
                </div>
                <div *ngIf="isSuccess" class="text_success">
                    {{sucessMessage}}
                </div>

                <collab-comp-button type="button" class="login-button" [buttonConfig]="loginButtonConfig" (onBtnClick)="login()"></collab-comp-button>            
            </div>
        </form>
    </div>
</div> -->